export const all = (...ss: string[]) => ss.join(' ');
